var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeSeatMinimal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#33302E",
    d: "M.1 18.1c0-1.8.2-6.2.3-8.8C.5 6 1.1 4 2.5 2.8 4.4 1.1 6.6.7 11.8.4 24-.2 36.4-.2 51.9 1c1.6.1 2.2.4 2.6.6.7.5.8 1 1 3.8.1 1.6.3 5.8.4 8.1-5.3-.3-14.4-.8-22.3-.8s-15 0-15.9.2c-1.7.2-2.5 1-2.7 1.4l41 7.5v6L.1 18.1zm-.1 3l55.8 10.5c0 1.5-.2 6.3-.3 9.1-.1 3.3-.8 5.3-2.2 6.6-1.9 1.7-4.1 2.1-9.3 2.4-12.1.5-24.5.5-40-.7-1.6-.1-2.2-.4-2.6-.6-.7-.5-.8-1-1-3.8-.1-1.9-.4-7.3-.5-9.1 7.2.5 18.3.8 27.3.8 2.3 0 8.1.1 9.7.1 1.2 0 2.9-.4 3.7-1.6L0 27.8v-6.7z"
  })));
}

export default SvgBadgeSeatMinimal;